function initButtons() {
    $(".listing--single, .btn, .select__item, .form-field--submit").mouseenter(function() {
        $(this).find(".arrow-btn").addClass("move");
        $(this).find(".arrow-btn").css("animation-iteration-count", "infinite");
    }).mouseleave(function() {
        $(this).find(".arrow-btn").css("animation-iteration-count", 1);
        setTimeout(function () {
            $(".arrow-btn").removeClass("move");
        }, 1000);
    });

    document.querySelectorAll(".editor-text a.btn--orange").forEach(btn => {
        if (!btn.querySelector("img")) {
            btn.insertAdjacentHTML("beforeend", `<span><img class="arrow-btn" src="/wp-content/themes/cis-scolaire/images/arrow-btn-white.png" alt="Voir"></span>`);
        }
    });
}
